// Signing out (or a session expiring) clears the browser's localStorage. Widget home-tile layouts
// and per-widget data (Momentum.storage) live there too, but they're namespaced per user and
// promised as "saved for you on this device" — so they survive a sign-out instead of vanishing on
// every logout or token expiry. Everything else is cleared exactly as before.

const PRESERVED_PREFIXES = ['wg_store:', 'wg_home_layout:'];

export function clearLocalStorageKeepingWidgets(): void {
  try {
    const kept: [string, string][] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && PRESERVED_PREFIXES.some(p => key.startsWith(p))) {
        const value = localStorage.getItem(key);
        if (value !== null) kept.push([key, value]);
      }
    }
    localStorage.clear();
    for (const [key, value] of kept) localStorage.setItem(key, value);
  } catch {
    try { localStorage.clear(); } catch { /* storage unavailable */ }
  }
}
